export default () => ({
  featureFlags: [],
  isSidebarCollapsed: false,
  isFetchingApplicationConfigs: false,
  elasticsearchEnabled: false,
  errorsFetchingApplicationConfigs: [],
  environment: "production",
  actor: null,
  account: null,
});
